import styled from '@emotion/styled';

const CommentContent = styled('div')`
  margin: 0.75rem;
`;

export default CommentContent;
